import { money } from "@/lib/format";
import { Users, DollarSign, MousePointerClick, Crown, Heart } from "lucide-react";

const Stat = ({ icon: Icon, label, value, accent, testid }) => (
    <div
        data-testid={testid}
        className="flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3"
    >
        <span
            className={`grid place-items-center h-9 w-9 rounded-lg ${
                accent === "heat"
                    ? "bg-heat/15 text-heat"
                    : "bg-brand/15 text-brand"
            }`}
        >
            <Icon className="h-4 w-4" />
        </span>
        <div className="leading-tight">
            <div className="font-heading text-lg font-semibold tabular">{value}</div>
            <div className="text-xs text-muted-foreground">{label}</div>
        </div>
    </div>
);

export const StatsBar = ({ stats, variant = "hype" }) => {
    if (!stats) return null;
    if (variant === "auction") {
        return (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                <Stat testid="stat-listings" icon={Users} label="Apps &amp; products ranked" value={stats.total_listings} />
                <Stat testid="stat-total-bids" icon={DollarSign} label="Total bids" value={money(stats.total_bids_usd)} accent="heat" />
                <Stat testid="stat-top-bid" icon={Crown} label="Top spot bid" value={money(stats.top_bid)} />
                <Stat testid="stat-clicks" icon={MousePointerClick} label="Total clicks" value={stats.total_clicks} accent="heat" />
            </div>
        );
    }
    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Stat testid="stat-listings" icon={Users} label="Apps listed" value={stats.count ?? 0} />
            <Stat testid="stat-likes" icon={Heart} label="Likes in play" value={stats.likes_in_play ?? 0} accent="heat" />
            <Stat testid="stat-top-likes" icon={Crown} label="Crowd #1 likes" value={stats.top_likes ?? 0} />
            <Stat testid="stat-top-host" icon={MousePointerClick} label="Crowd #1" value={stats.top_host || "—"} />
        </div>
    );
};
